// extracted by mini-css-extract-plugin
export default {"wrapper":"TabsBarMobile_wrapper__BwZTl"};